import { StyleRules } from '@material-ui/core/styles';
import { SliderClassKey } from '@material-ui/core/Slider';

import { core as theme } from '../styles/core';

export const MuiSlider: Partial<StyleRules<SliderClassKey>> = {
  root: {
    height: 5,
  },
  thumb: {
    width: 24,
    height: 24,
    marginTop: -11,
    marginLeft: -12,
    backgroundColor: theme.palette.common.white,
    border: '1px solid currentColor',
    '&$disabled': {
      width: 16,
      height: 16,
      marginTop: -6,
      marginLeft: -8,
    },
  },
  valueLabel: {
    left: 'calc(-50% + 8px)',
  },
  rail: {
    height: 5,
    borderRadius: 2.5,
    backgroundColor: theme.palette.grey[100],
    opacity: 1,
  },
  track: {
    height: 5,
    borderRadius: 2.5,
  },
};
